import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "Editar dados do cliente", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import {
  IonContent,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonLabel,
  IonInput,
  IonList,
  IonItem,
  loadingController,
  IonCheckbox,
  alertController,
} from "@ionic/vue";
import { reactive, ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { key } from "../store";
import { useRouter } from "vue-router";
import { getCep } from "../service/cep";
import { getCoordinate, getDistance } from "@/service/mapbox";
// import { beakerSharp, constructOutline, logoStackoverflow } from 'ionicons/icons';
// import { maskito as vMaskito } from '@maskito/vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutAlteraCliente',
  setup(__props) {

let clienteData = reactive({});
let enderecoData = reactive({});

const store = useStore(key);
const router = useRouter();

clienteData = store.state.user[0];
enderecoData = store.state.user.slice(-1)[0];

const nome = ref(clienteData.nome);
const telefone1 = ref();
const cpf = ref();
const email = ref();
const endereco = ref();
const numero = ref();
const complemento = ref();
const referencia = ref();
const bairro = ref();
const cidade = ref();
const uf = ref();
const cep = ref();
const lgpd = ref(false);

onMounted(() => {
  email.value = clienteData.email;
  endereco.value = enderecoData.endereco;
  numero.value = enderecoData.numero;
  complemento.value = enderecoData.complemento;
  referencia.value = enderecoData.referencia;
  bairro.value = enderecoData.bairro;
  cidade.value = enderecoData.cidade;
  uf.value = enderecoData.uf;
  cep.value = enderecoData.cep;
  cpf.value = clienteData.cpf;
});

async function showLoading() {
  const loading = await loadingController.create({
    message: "Cliente alterado com sucesso",
    duration: 1000,
    spinner: "circles",
  });

  loading.present();
}

const showError = async () => {
  const alert = await alertController.create({
    header: "Alerta",
    subHeader: "Não foi possivel criar o novo cliente",
    message: "Verifique os campos digitados!",
    buttons: ["OK"],
  });
  await alert.present();
};

async function salvarDadosCliente() {
  if (
    lgpd.value == true &&
    nome.value != "" &&
    telefone1.value != "" &&
    email.value != "" &&
    cpf.value != "" &&
    endereco.value != "" &&
    numero.value != "" &&
    cep.value != ""
  ) {
    const endereco_busca = encodeURI(
      endereco.value + " " + numero.value + "," + cidade.value + "," + uf.value
    );
    const mapbox = await getCoordinate(endereco_busca);
    console.log(mapbox.features[0].center);

    const distance = await getDistance(
      mapbox.features[0].center[1],
      mapbox.features[0].center[0]
    );
    const myditance = distance.routes[0].distance;
    const datacli: Array<any> = [
      {
        nome: nome.value,
        telefone1: telefone1.value,
        email: email.value,
        cpf: cpf.value },
        {
        endereco: endereco.value,
        numero: numero.value,
        complemento: complemento.value,
        referencia: referencia.value,
        bairro: bairro.value,
        cidade: cidade.value,
        uf: uf.value,
        cep: cep.value,
        latitude: mapbox.features[0].center[1],
        longitude: mapbox.features[0].center[0],
        distancia: myditance,
      },
    ];
    store.dispatch("updateClientData", datacli).then(() => {
      showLoading().then(() => {
        router.push({ name: "checkoutcliente" });
      });
    });
  } else {
    showError();
  }
}

watch(cep, async () => {
  if (cep.value.length > 7) {
    // console.log(cep.value);
    const newData = await getCep(cep.value).then((rr) => {
      endereco.value = rr.logradouro;
      (bairro.value = rr.bairro),
        (cidade.value = rr.localidade),
        (uf.value = rr.uf);
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonGrid), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRow), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), null, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _createVNode(_unref(IonList), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "fixed" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Nome")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: nome.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nome).value = $event)),
                            disabled: true
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "fixed" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Email")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: email.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "fixed" }, {
                            default: _withCtx(() => [
                              _createTextVNode("CPF")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: cpf.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((cpf).value = $event)),
                            maxlength: "11",
                            inputmode: "number"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "fixed" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Fone/Whatsapp")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            value: 
                  '(' +
                  _unref(clienteData).telefone1.substring(0, 2) +
                  ')' +
                  _unref(clienteData).telefone1.substring(2)
                ,
                            disabled: true,
                            inputmode: "numeric"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "fixed" }, {
                            default: _withCtx(() => [
                              _createTextVNode("CEP")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: cep.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((cep).value = $event)),
                            inputmode: "numeric"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "fixed" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Endereço")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: endereco.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((endereco).value = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "fixed" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Número")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: numero.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((numero).value = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode("Complemento")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: complemento.value,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((complemento).value = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "fixed" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Referência")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: referencia.value,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((referencia).value = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "fixed" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Bairro")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: bairro.value,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((bairro).value = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "fixed" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Cidade")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: cidade.value,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((cidade).value = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "fixed" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Estado")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: uf.value,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((uf).value = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCheckbox), {
                            slot: "start",
                            modelValue: lgpd.value,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((lgpd).value = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_unref(IonLabel), { class: "mini" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Confirmo meus dados para cadastro "),
                              _hoisted_2,
                              _createTextVNode(" no APP Uniboi em acordo com a LGPD")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonRow), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    expand: "block",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (salvarDadosCliente()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Salvar alterações ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})